import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import api from '../../../services/api';
import { getSubdomainUsername, getUsernameSyncOnly } from '../../../utils/subdomain';
import { buildMediaUrl } from '../../../utils/mediaUrl';

const PublicLegacy = () => {
  const { username: urlUsername } = useParams();
  const subdomainUser = getSubdomainUsername();
  const cachedCustomDomainUser = getUsernameSyncOnly();
  const username = urlUsername || subdomainUser || cachedCustomDomainUser;

  const [data, setData] = useState({ section: null, items: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await api.get(`/business/legacy/public/${username}/`);
        // API returns array directly
        const items = Array.isArray(res.data) ? res.data : (res.data.items || []);
        setData({
          section: res.data.section || {},
          items: items
        });
      } catch (err) {
        console.error('Error fetching legacy:', err);
      } finally {
        setLoading(false);
      }
    };
    if (username) fetchData();
  }, [username]);

  if (loading) {
    return (
      <div style={{ padding: '4rem 2rem', textAlign: 'center' }}>
        <div style={{
          width: '2rem', height: '2rem',
          border: '3px solid rgba(255,255,255,0.1)',
          borderTopColor: '#6366f1',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          margin: '0 auto'
        }} />
      </div>
    );
  }

  if (!data.items.length) {
    return (
      <div id="section-legacy" style={{ padding: '4rem 2rem', textAlign: 'center', backgroundColor: '#0f172a' }}>
        <p style={{ color: 'rgba(255,255,255,0.5)' }}>No legacy content available yet.</p>
      </div>
    );
  }

  return (
    <div style={{ padding: '4rem 2rem', backgroundColor: '#0f172a' }}>
      <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <h2 style={{ fontSize: '2.5rem', fontWeight: '700', color: '#fff', marginBottom: '0.5rem' }}>
            {data.section?.title || 'Our Legacy'}
          </h2>
          {data.section?.subtitle && (
            <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '1.1rem' }}>
              {data.section.subtitle}
            </p>
          )}
        </div>

        {/* Timeline Layout */}
        <div style={{ position: 'relative' }}>
          {/* Center line */}
          <div style={{
            position: 'absolute',
            left: '50%',
            top: 0,
            bottom: 0,
            width: '2px',
            backgroundColor: 'rgba(99, 102, 241, 0.3)',
            transform: 'translateX(-50%)'
          }} />

          {data.items.map((item, index) => (
            <div
              key={item.id || index}
              style={{
                display: 'flex',
                justifyContent: index % 2 === 0 ? 'flex-start' : 'flex-end',
                position: 'relative',
                marginBottom: '2rem'
              }}
            >
              {/* Dot on timeline */}
              <div style={{
                position: 'absolute',
                left: '50%',
                top: '1.5rem',
                width: '1rem',
                height: '1rem',
                backgroundColor: '#6366f1',
                borderRadius: '50%',
                transform: 'translateX(-50%)',
                zIndex: 1
              }} />

              {/* Content card */}
              <div style={{
                width: '45%',
                padding: '1.5rem',
                backgroundColor: 'rgba(255,255,255,0.05)',
                borderRadius: '1rem',
                border: '1px solid rgba(255,255,255,0.1)'
              }}>
                {item.year && (
                  <span style={{
                    display: 'inline-block',
                    padding: '0.25rem 0.75rem',
                    backgroundColor: 'rgba(99, 102, 241, 0.2)',
                    color: '#6366f1',
                    borderRadius: '999px',
                    fontSize: '0.875rem',
                    fontWeight: '600',
                    marginBottom: '0.75rem'
                  }}>
                    {item.year}
                  </span>
                )}
                <h3 style={{ color: '#fff', fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.5rem' }}>
                  {item.title}
                </h3>
                <p style={{ color: 'rgba(255,255,255,0.6)', lineHeight: '1.6' }}>
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PublicLegacy;
